export default __webpack_public_path__ + "static/media/WhitePapersImg7.f1bfbbce.png";